import { I18n } from '@calendly/i18n'

import {
  getUpgradeEnforcementPaywallConfig,
  useShowActivationEnforcement,
  useShowCustomizationEnforcement
} from '../../notifications/subsections/upgrade_enforcement'
import { UpgradeInlineBanner } from '../upgrade_inline_banner'

const getBannerCopy = (kind) => {
  switch (kind) {
    case 'invitee_invitation':
    case 'invitee_confirmation':
      return {
        title: I18n.t(
          'publisher.event_type_editor.sections.more_options.notifications.notification_free_plan.customize_confirmation_message.title'
        ),
        message: I18n.t(
          'publisher.event_type_editor.sections.more_options.notifications.notification_free_plan.customize_confirmation_message.message'
        )
      }
    case 'invitee_cancellation':
      return {
        title: I18n.t(
          'publisher.event_type_editor.sections.more_options.notifications.notification_free_plan.customize_cancellation_message.title'
        ),
        message: I18n.t(
          'publisher.event_type_editor.sections.more_options.notifications.notification_free_plan.customize_cancellation_message.message'
        )
      }
    case 'invitee_reminder':
    case 'invitee_sms_reminder':
      return {
        title: I18n.t(
          'publisher.event_type_editor.sections.more_options.notifications.notification_free_plan.customize_reminders.title'
        ),
        message: I18n.t(
          'publisher.event_type_editor.sections.more_options.notifications.notification_free_plan.customize_reminders.message'
        )
      }
    case 'invitee_email_follow_up':
      return {
        title: I18n.t(
          'publisher.event_type_editor.sections.more_options.notifications.notification_free_plan.customize_follow_ups.title'
        ),
        message: I18n.t(
          'publisher.event_type_editor.sections.more_options.notifications.notification_free_plan.customize_follow_ups.message'
        )
      }
    default:
      return null
  }
}

export const NotificationFreePlanBanner = ({ kind, isMETParent }) => {
  const showActivationEnforcement = useShowActivationEnforcement({ isMETParent, kind })
  const showCustomizationEnforcement = useShowCustomizationEnforcement({ isMETParent, kind })
  const paywallConfig = getUpgradeEnforcementPaywallConfig({
    kind,
    showActivationEnforcement,
    showCustomizationEnforcement
  })
  const copy = getBannerCopy(kind)

  if (!paywallConfig || !copy) return null

  return (
    <UpgradeInlineBanner
      data-testid="notification-free-plan-banner"
      title={copy.title}
      message={copy.message}
      explorePlansLabel={I18n.t(
        'publisher.event_type_editor.sections.more_options.notifications.notification_free_plan.explore_plans'
      )}
      featureKey={paywallConfig.featureKey}
      paywall={paywallConfig.paywallName}
    />
  )
}
